import { Injectable, inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppFacade } from '@web/store/app/app.facade';

@Injectable({
    providedIn: 'root',
})
export class WebTabGuardService {
    private readonly appFacade = inject(AppFacade);

    private storageKey = 'constructor_open';

    constructor() {
        this.listenForStorageChanges();
    }

    enterConstructor() {
        const currentTabId = Math.random().toString(36).substring(2);
        localStorage.setItem(this.storageKey, JSON.stringify({ tabId: currentTabId, timestamp: Date.now() }));
    }

    private listenForStorageChanges() {
        fromEvent<StorageEvent>(window, 'storage')
            .pipe(
                filter((event) => event.key === this.storageKey && event.newValue !== null),
                map((event) => JSON.parse(event.newValue || '{}'))
            )
            .subscribe((data) => {
                if (data) {
                    this.redirectIfAnotherTabOpened();
                }
            });
    }

    private redirectIfAnotherTabOpened() {
        this.appFacade.exit(true);
    }
}
